<template>
  <div>
    <div :class="getLoginTop()" role="navigation">
      <div class="row login-top-row-new">
        <div v-show="newVersion()" class="col-sm-4">
          <div class="new-logo-container">
            <h1>
              <img :src="logo" class="img-fluid" :alt="LG('HP_altLogo')" />
            </h1>
          </div>
        </div>
        <div class="col">
          <div :class="getTopUIClass()">
            <!--Message that lets you create an account  (px-2 leaves padding between each element) -->
            <div :class="getLoginMessageClass()" v-show="!loggedin">
              {{ LG("LO_loginTextStart") }} <b-link to="/inscription">{{ LG("LO_loginTextLink") }}</b-link> {{ LG("LO_loginTextEnd") }}
            </div>

            <!--Login/Logout button-->
            <div class="px-2">
              <!-- <b-button id="loginButton-id" v-on:click="onLoginButtonClicked" aria-controls="collapse-1" :class="getLoginButton()">{{ getLoginButtonLabel() }}</b-button> -->
              <b-button id="loginButton-id" v-b-toggle="'collapse-1'" :class="getLoginButton()">{{ getLoginButtonLabel() }}</b-button>
              <!--Login dropdown-->
              <div class="login-dropdown" ref="loginDropdownMenuRef">
                <b-collapse class="login-dropdown-collapse" id="collapse-1" v-model="loginPanelOpen">
                  <div v-if="loggedin">
                    <!--User icon, name and logout button shown if logged in-->
                    <h3 class="centered-element">
                      <b>{{ userName }}</b>
                    </h3>
                    <span class="centered-element">{{ emailAddress }}</span>
                    <span class="centered-element"><AvatarIcon id="mainIcon-id" width="100"></AvatarIcon></span>
                    <!--Logout button-->
                    <div class="row">
                      <button v-on:click="onLogoutButtonClicked()" class="connect-button centered-element">{{ LG("LO_logoutButtonText") }}</button>
                    </div>
                    <br aria-hidden="true" />
                  </div>
                  <div v-show="!loggedin">
                    <p v-html="showErrorMessages()"></p>
                    <br aria-hidden="true" />

                    <div class="row" v-show="forgotPasswordUI">
                      <p class="centered-element">{{ LG("LO_forgotPasswordText") }}</p>
                    </div>

                    <b-form @submit.prevent="handleSubmit">
                      <b-form-group :label="LG('LO_emailLabel')" label-for="email">
                        <b-form-input id="email" type="email" class="login-input centered-element" v-model="email" :placeholder="LG('LO_emailPlaceholder')"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="LG('LO_passwordLabel')" label-for="password" v-show="!forgotPasswordUI">
                        <b-form-input id="password" type="password" class="login-input centered-element" v-model="password" :placeholder="LG('LO_passwordPlaceholder')"></b-form-input>
                      </b-form-group>
                      <br aria-hidden="true" />
                      <div>
                        <!--Show login button, or when logging-in show spinner and disable button-->
                        <button v-show="!loggingin" class="btn btn-primary centered-element connect-button">{{ getConnectButtonText() }}</button>
                        <button v-show="loggingin" class="btn btn-primary centered-element connect-button" disabled>{{ LG("LO_connectText") }}</button>
                        <br aria-hidden="true" />
                        <button class="btn btn-primary centered-element connect-button" v-on:click.prevent="onCancelButtonClicked()">{{ LG("LO_cancelLabel") }}</button>
                        <img v-show="loggingin" :src="spinnerUrl" alt="" />
                      </div>
                    </b-form>
                    <br aria-hidden="true" />
                    <div class="row" v-show="!forgotPasswordUI">
                      <a class="centered-element" href="#" v-on:click.prevent="onForgotPasswordButtonClicked()">{{ LG("LO_forgotPasswordText") }}</a>
                    </div>
                    <br aria-hidden="true" />
                  </div>
                </b-collapse>
              </div>
            </div>
            <AvatarIcon id="subIcon-id" :width="getAvatarWidth()" dropdown="yes"></AvatarIcon>
            <button v-show="newVersion()" class="mute-button mute-button-home" v-on:click="onVolumeClicked()" aria-label="volume"><font-awesome-icon :icon="getVolumeIcon()" /></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvatarIcon from "../components/AvatarIcon.vue";

export default {
  name: "Login",
  props: {},
  components: {
    AvatarIcon,
  },
  data() {
    return {
      // Images
      spinnerUrl: "data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==",
      logo: require("@/assets/menus/main/logo-color.png"),

      // Variables
      errors: [],
      email: "",
      emailmax: "20",
      password: "",
      passwordmax: "20",
      loginPanelOpen: false,
      forgotPasswordUI: false,
    };
  },
  mounted() {},
  computed: {
    loggedin() {
      return this.$store.state.loggedin;
    },
    loggingin() {
      return this.$store.state.loggingin;
    },
    userName() {
      if (this.$store.state.user == null) {
        return "";
      }
      var fullName = this.$store.state.user.firstName + " " + this.$store.state.user.lastName;
      return fullName;
    },
    emailAddress() {
      if (this.$store.state.user == null) {
        return "";
      }
      return this.$store.state.user.email;
    },
  },
  methods: {
    getLoginButtonLabel() {
      if (!this.loggedin) {
        return this.LG("LO_loginButtonText");
      } else {
        return this.userName;
      }
    },
    getAvatarWidth() {
      if (this.newVersion()) {
        return "60";
      }
      return "25";
    },
    getLoginButton() {
      if (this.newVersion()) {
        return "login-button-new";
      }
      return "login-button";
    },
    getLoginTop() {
      if (this.newVersion()) {
        return "login-top-new";
      }
      return "login-top";
    },
    getTopUIClass() {
      if (!this.newVersion()) {
        return "row justify-content-end align-items-center";
      }
      return "row new-top-ui justify-content-end align-items-center";
    },
    getLoginMessageClass() {
      if (this.newVersion()) {
        return "col login-message login-message-new px-2";
      }
      return "login-message px-2";
    },
    documentClick(e) {
      var loginButtonElement = document.getElementById("loginButton-id");

      var clickedElement = e.target;
      if (clickedElement == loginButtonElement) {
        //console.log("ignore focus check for login buttons");
        return;
      }

      // When the page is clicked on, if clicking outside this element, close the panel
      var dropDownRef = this.$refs.loginDropdownMenuRef;
      if (dropDownRef != null) {
        if (dropDownRef != clickedElement) {
          if (!dropDownRef.contains(e.target)) {
            // console.log("Not contained! closing panel");
            this.closePanel();
          }
        }
      }
    },
    showErrorMessages() {
      var errorMessages = "";
      if (this.errors.length > 0) {
        errorMessages = this.LG("LO_errorMessage");
      }
      for (var i = 0; i < this.errors; i++) {
        errorMessages = errorMessages + "<br />" + this.errors[i];
      }

      return errorMessages;
    },
    getConnectButtonText() {
      // If in forgot password mode, label the button as "Send email", otherwise it is the "Login" button
      if (this.forgotPasswordUI) {
        return this.LG("LO_sendEmailText");
      } else {
        return this.LG("LO_connectText");
      }
    },
    onLoginButtonClicked() {
      if (!this.loginPanelOpen) {
        this.openPanel();
      } else {
        this.closePanel();
      }
    },
    onLogoutButtonClicked() {
      this.logout();
    },
    logout() {
      this.$store.commit("clearUserList");
      this.closePanel();
      if (this.$store.state.loggedin) {
        console.log("***** LOGGING OUT, and removing the local storage user info!!!");
        localStorage.removeItem("user");
        localStorage.removeItem("gamestate");

        this.$store.dispatch("logout");
      } else {
        console.log("CAN'T LOGOUT!!!! not logged in!!!");
      }
    },
    handleSubmit() {
      this.clearErrorArray();
      if (this.forgotPasswordUI) {
        this.SendForgotPasswordEmail(this.email);
      } else {
        this.login(this.email, this.password);
      }
    },
    SendForgotPasswordEmail(email) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      };

      return fetch(`/users/forgot`, requestOptions)
        .then(this.handleResponse)
        .then((user) => {
          // Just close panel, don't login until email link us used
          this.closePanel();

          return user;
        });
    },
    login(email, password) {
      this.$store.commit("startLogin");

      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      };

      return fetch(`/users/authenticate`, requestOptions)
        .then(this.handleResponse)
        .then((user) => {
          // login successful if there's a jwt token in the response
          if (user != null && user.token != null) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            var userStringText = JSON.stringify(user);
            console.log("***** STORING User = " + userStringText);
            localStorage.setItem("user", userStringText);
            this.$store.commit("completeLogin", user);
            this.closePanel();

            // Load in our game state - if this table doesn't exist yet, this will create one in DB as well
            this.loadGameState();
          } else {
            console.log("NO User token found!");
          }

          return user;
        });
    },
    // This is the API that initially reades the game state from the backend DB - it's called once login completes
    loadGameState() {
      if (this.loggedin == false) {
        console.log("Not logged in, so cannot load game state.");
        return;
      }
      this.$store.commit("startLoadingGameState");
      this.$store.commit("updateDbInfo");

      var authheader = {};
      if (this.$store.state.user.token) {
        authheader = { authorization: "bearer " + this.$store.state.user.token };
      }

      const requestOptions = {
        method: "GET",
        headers: authheader,
      };

      console.log("Loading game state from DB...");

      // Fetch game state based on email
      var email = this.$store.state.user.email;
      return fetch(`/gamestate/${email}`, requestOptions)
        .then(this.handleResponse)
        .then((gamestate) => {
          if (gamestate != null) {
            console.log("gamestate received, and here is raw data:" + gamestate);
            gamestate.email = email;
            var gamestateStringInvalid = JSON.stringify(gamestate.gameInfo);
            console.log("INVALID ONE LOOKS LIKE THIS:" + gamestateStringInvalid);
            var gamestateString = gamestateStringInvalid.replace(/\\/g, "");
            gamestateString = gamestateString.replace(/^"(.+(?="$))"$/, "$1");
            console.log("gamestate received:" + gamestateString);

            if (gamestateString != null) {
              console.log("String is not null");
              // Save our game state into local storage for easy access on refresh
              localStorage.setItem("gamestate", gamestateString);

              this.loadGameStateString(gamestateString);

              if (gamestate.email == "admin@admin.com") {
                this.requestUserList();
              }
            } else {
              console.log("String is not null");
            }
          } else {
            console.log("Got a null gamestate from the backend.");
          }

          return gamestate;
        });
    },
    setError(text) {
      this.errors.push(text);
      this.$store.commit("cancelLogin");

      console.log("ERROR received during login, CANCEL!  Error:" + text);
    },
    handleResponse(response) {
      console.log("Received response: " + response);

      if (response == null) {
        console.log("response is null");
        return;
      }
      return response
        .text()
        .then((text) => {
          const data = text && JSON.parse(text);
          if (!response.ok) {
            console.log("response is not OK, logging out.");
            this.$store.dispatch("logout");

            const error = (data && data.message) || response.statusText;
            this.setError(this.errorLabel + ": " + error);

            return Promise.reject(error);
          }
          return data;
        })
        .catch((err) => {
          if (this.errors.length == 0) {
            this.setError(this.genericError);
          }
          console.log("Error was caught: " + err);
        });
    },
    onForgotPasswordButtonClicked() {
      this.clearErrorArray();
      this.forgotPasswordUI = true;
    },
    clearErrorArray() {
      if (this.errors != null && this.errors.length > 0) {
        this.errors.splice(0);
        this.errors.length = 0;
      }
    },
    onCancelButtonClicked() {
      if (this.forgotPasswordUI) {
        this.clearErrorArray();
        this.forgotPasswordUI = false;
      } else {
        this.closePanel();
      }
    },
    openPanel() {
      this.clearErrorArray();
      this.loginPanelOpen = true;
    },
    closePanel() {
      this.clearErrorArray();
      this.loginPanelOpen = false;
      this.forgotPasswordUI = false;
    },

    getVolumeIcon() {
      if (this.$store.state.gamestate.muted) {
        return "volume-mute";
      } else {
        return "volume-up";
      }
    },
    onVolumeClicked() {
      if (!this.$store.state.gamestate.muted) {
        this.muteAllAudio();
        this.$store.commit("setMuted", true);
      } else {
        //this.unmuteAllAudio();
        this.playRegisteredAudio();
        this.$store.commit("setMuted", false);
      }
      this.$emit("mute-clicked");
    },
    requestUserList() {
      if (this.loggedin == false) {
        console.log("Not logged in, so cannot request user list.");
        return;
      }

      var authheader = {};
      if (this.$store.state.user.token) {
        authheader = { authorization: "bearer " + this.$store.state.user.token };
      }

      const requestOptions = {
        method: "GET",
        headers: authheader,
      };

      console.log("Loading USERS list from DB...");

      return fetch(`/users/`, requestOptions)
        .then(this.handleResponse)
        .then((users) => {
          if (users != null) {
            console.log("users received, and here is raw data:" + users);
            for (var i = 0; i < users.length; i++) {
              console.log(users[i].firstName);
              console.log(users[i].lastName);
              console.log(users[i].email);
              this.$store.commit("addUserToList", users[i]);
            }
          }
          return users;
        });
    },
  },
  created() {
    document.addEventListener("mousedown", this.documentClick);
  },
  destroyed() {
    document.removeEventListener("mousedown", this.documentClick);
  },
};
</script>

<style scoped>
.mute-button {
  padding: 30px;
  color: #154f68;
  background-color: transparent !important;
  border: none;
  font-size: 20px;
  width: 60px;
  height: 20px;
  text-align: center;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.login-top {
  font-family: "Poppins";
  font-size: 12px;
  position: relative;
  left: 1%;
  background-color: #052433;
  width: 100%;
  min-height: 40px;
  z-index: 2;
}

.login-top a:link {
  color: white !important;
  text-decoration: underline !important;
}

.login-top a:visited {
  color: white !important;
  text-decoration: underline !important;
}

.login-top a:hover {
  color: aquamarine !important;
}

.login-top a:active {
  color: aquamarine !important;
}

.login-top-new {
  font-family: "Poppins";
  font-size: 12px;
  position: relative;
  left: 1%;
  background-color: #e8eff2;
  width: 100%;
  min-height: 40px;
  z-index: 2;
}

.login-top-row-new {
  /*background-color: purple;*/
  max-width: 98% !important;
}

.login-message {
  text-align: end;
  color: white;
}

.login-message-new {
  max-width: 300px !important;
  font-size: 15px;
  color: #154f68;
  text-align: left;
}

.login-dropdown {
  background-color: white;
  color: black;
  margin-top: 15px;
  margin-left: 30px;
  z-index: 1;
  position: absolute;
}
.login-dropdown-collapse {
  min-width: 250px;
  padding: 0 15px;
  font-size: 15px;
  border: 1px solid #c3b8c5;
}
.login-input {
  background-color: #e5e2e2;
  border-radius: 25px;
  text-align: center;
}

.login-button {
  background-color: white;
  color: #5d7e15;
  text-align: center;
  min-width: 80px;
  height: 30px;
  clip-path: polygon(10% 20%, 85% 0%, 100% 100%, 0% 100%);
  font-size: 11px;
  padding-left: 15px;
  padding-right: 15px;
}

.login-button-new {
  background-color: #3f5d12;
  color: white;
  text-align: center;
  min-width: 150px;
  height: 40px;
  clip-path: polygon(10% 20%, 85% 0%, 100% 100%, 0% 100%);
  font-size: 14px;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.connect-button {
  font-size: 14px !important;
  color: white !important;
  background-color: #3f5d12 !important;
  text-align: center;
}

/*.collapsing {
        -webkit-transition: none;
        transition: none;
        display: none;
    }*/
.mute-button-home {
  padding-top: 10px !important;
  padding-right: 50px !important;
}

.new-logo-container {
  /*border: 2px solid red;*/
}

.new-top-ui {
  padding-top: 45px;
  /*border: 2px solid yellow;*/
}

@media only screen and (max-width: 800px) {
  .new-logo-container {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .login-message-new {
    padding-left: 30px !important;
  }

  .login-button-new {
    min-width: 50px;
    font-size: 10px;
  }
}
</style>
